import {Skeleton} from '@mantine/core';
import type {z} from 'zod';
import type {CompaniesSchema} from '../../../../core/entities/usersMe/schema';
import {CompanyCardPickup} from '../../../company/components/Container/Presenter/CompanyCardPickup';
import {SectionHeader} from './Presenter/SectionHeader';
import {CAROUSEL_CONFIG} from './constants';

type PickupCompany = z.infer<typeof CompaniesSchema>;

type Props = {
  componentId: string;
  title: string;
  description?: string;
  isLoading: boolean;
  companies?: PickupCompany[];
};

export const CompanyPickUpSection = ({
  componentId,
  title,
  description,
  isLoading,
  companies,
}: Props) => {
  if (companies && companies.length === 0) {
    return null;
  }

  return (
    <div id={componentId} className="mt-8 w-full py-16">
      <div className="pc:w-[1200px]">
        <SectionHeader
          componentId={componentId}
          title={title}
          description={description}
        />

        <div className="flex mt-16 gap-16 overflow-x-scroll">
          {isLoading ? (
            <CompanyCardSkeletons />
          ) : (
            <CompanyCardPickUps
              companies={companies ?? []}
              componentId={componentId}
            />
          )}
        </div>
      </div>
    </div>
  );
};

const CompanyCardPickUps = ({
  companies,
  componentId,
}: {companies: PickupCompany[]; componentId?: string}) => {
  return (
    <>
      {companies.map((company) => (
        <div key={company.id} className="rounded-16 mb-8">
          <CompanyCardPickup
            company={company}
            sizeClassName="w-[320px] pc:w-[370px]"
            componentId={`${componentId}-item`}
          />
        </div>
      ))}
    </>
  );
};

const CompanyCardSkeletons = () => {
  return Array.from({length: CAROUSEL_CONFIG.SKELETON_COUNT}).map(
    (_, index) => (
      <div key={`skeleton-company-${index}`}>
        <Skeleton
          height={CAROUSEL_CONFIG.CARD_HEIGHT.COMPANY}
          width={CAROUSEL_CONFIG.PC.COMPANY_CARD_WIDTH}
        />
        <Skeleton height={30} width={CAROUSEL_CONFIG.PC.COMPANY_CARD_WIDTH} />
        <Skeleton height={30} width={CAROUSEL_CONFIG.PC.COMPANY_CARD_WIDTH} />
      </div>
    ),
  );
};
